window.Products.Clothing.PremiumCrewneck = function() {
};
window.Products.Clothing.PremiumCrewneck.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumCrewneck.dpi = 150;
window.Products.Clothing.PremiumCrewneck.has_3d = true;
window.Products.Clothing.PremiumCrewneck.id = 110;
window.Products.Clothing.PremiumCrewneck.slug = 'premium-crewneck';
window.Products.Clothing.PremiumCrewneck.syncColors = true;
window.Products.Clothing.PremiumCrewneck.texturesLoaded = 0;
window.Products.Clothing.PremiumCrewneck.texturesLoading = false;
window.Products.Clothing.PremiumCrewneck.use_glb = true;

window.Products.Clothing.PremiumCrewneck.prototype.outsideObject = 0;
window.Products.Clothing.PremiumCrewneck.prototype.detailsObject = 1;
window.Products.Clothing.PremiumCrewneck.prototype.position = 0.1;

window.Products.Clothing.PremiumCrewneck.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumCrewneck.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"navy_blue": 0x2e2f41,
		"dark_heather": 0x48474c,
		"maroon": 0x701b2f,
		"ivory": 0xdbd6bf,
		"sky_blue": 0xafc8e6,
		"kiwi": 0xacc3a9,
		"gold": 0xfeb53d, // No ref
		"peach": 0xf0d0b3,
		"lavender": 0xd3ccea,
		"purple": 0x443169, // No ref
		"pink": 0xe5c5d2,
		"royal_blue": 0x0067bc,
		"sport_grey": 0xc1c0c5,
	};

	return new THREE.Color(colors[_name]);
};